import axios from 'axios';

export const authService = {
    /** Founding Source */

    createFundingSourceService: (body) => axios.post('/funding', body, { auth: true }),

    editFundingSourceService: (id, body) => axios.patch(`/funding/${id}`, body, { auth: true }),

    editFsSourceGroupingService: (id, body) => axios.patch(`/funding/${id}/billingSettings`, body, { auth: true }),

    editCms1500SettingsService: (id, body) => axios.patch(`/funding/${id}/cms1500Settings`, body, { auth: true }),

    getFundingSourceService: (data) => axios.get('/funding', { auth: true, params: { ...data } }),

    getFoundingSourceByIdService: (id) => axios.get(`/funding/${id}`, { auth: true }),

    changeFundingSourceStatusService: (id, path, status, body) => axios.patch(`/${path}/${id}/${status}`, body, { auth: true }),

    deleteFundingSourceService: (id) => axios.delete(`/funding/${id}`, { auth: true }),

    getFundingSourceClientsService: (id) => axios.get(`/enrollment/funder/${id}`, { auth: true }),

    getPayerCapabilitiesService: (params) => axios.get(`/funding/capabilities`, { auth: true, params: params }),

    checkPayerId: (code) => axios.get(`/funding/exists/shortName`, { auth: true, params: { shortName: code } }),

    /** End */

    /** Founding Source Service */

    getFSServiceByIdService: (id, data) => axios.get(`/funding/${id}/service`, { auth: true, params: { ...data } }),

    createFSServiceByIdService: (id, body) => axios.post(`/funding/${id}/service`, body, { auth: true }),

    editFSServiceService: (id, body) => axios.patch(`/funding/service/${id}`, body, { auth: true }),

    changeFundingSourceServiceStatus: (id, body) => axios.patch(`/funding/service/${id}`, body, { auth: true }),

    /** End */

    /** Modifiers */

    getServiceModifierService: (serviceId) => axios.get(`/chargeRate/service/${serviceId}`, { auth: true }),

    createModifierService: (body) => axios.post(`/chargeRate`, body, { auth: true }),

    editModifierService: (id, body) => axios.patch(`/chargeRate/${id}`, body, { auth: true }),

    modifierStatusService: (chargeRateId) => axios.patch(`/chargeRate/${chargeRateId}/inactivate`, null, { auth: true }),

    /** End */

    setStatusService: (id, status) => axios.patch(`/funding/${id}/status/${status === 'ACTIVE'}`, null, { auth: true }),

    /** Enrollment */

    addPayerEnrollmentService: (payerId, params) => axios.patch(`/funding/${payerId}/enrollment`, null, { auth: true, params: params }),

    changePayerEnrollmentStatusService: ({ fundingId, enrollmentId, active }) =>
        axios.patch(`/funding/${fundingId}/enrollment/${enrollmentId}/status/${active}`, null, { auth: true }),

    /** End */

    fundingUniqueServicesService: () => axios.get(`/funding/service/unique-services`, { auth: true }),
};
